export const API = "AIzaSyCpBFsGdMzJ_qo1PPGUM6i0g__WTZuzTQk"